var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reg-container col-md-12 p-4 text-center",style:({ 'background-image': 'url(' + _vm.imageUrl + ')' })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }